// import request from '../utils/request/next-request';

// export async function getVideoPlayToken() {
//   const url = `${process.env.NEXT_PUBLIC_CONSOLE_AUTH_URL}/common/extend/video-play-token`;
//   const tokenRes = await request({
//     method: 'get',
//     url,
//     data: {},
//   })
//   console.log('token', tokenRes);
//   return tokenRes.data;
// }
export async function getVideoPlayToken() {
  const url = `${process.env.NEXT_PUBLIC_CONSOLE_AUTH_URL}/common/extend/video-play-token`;
  // const url = 'http://localhost:5000/api/common/extend/video-play-token';
  const token = await fetch(url, {
    method: 'get',
  })
    .then((res) => res.json())
    .then((res) => {
      return res.data;
    });
  return token;
}
